import Vue from 'vue'
import uiOpen from './uiOpen.vue'

const VueComponent = Vue.extend(uiOpen)
const vm = new VueComponent().$mount()
let init = false
let defaultOptions = {}

const openApp = function (options) {
  Object.assign(vm, defaultOptions, options, {
    type: 'openApp'
  })

  if (!init) {
    document.body.appendChild(vm.$el)
    init = true
  }
  return vm.openApp('el')
}

export default openApp


// WEBPACK FOOTER //
// ./src/component/uiOpen/index.js